import React, { useState ,useEffect}  from "react";
import "./Logger.scss";
import { Table } from "antd";
import {
  get
} from "../../../api/get";
import {
  getAccessTokenApi
} from "../../../api/auth";
import {
  getUserRol
} from "../../../api/user";



const columns = [
  {
    title: "Iteration",
    key: "Iteration",
    dataIndex: "Iteration",
  },
  {
    title: "Id",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
  },
  {
    title: "Date",
    dataIndex: "Date",
    key: "Date",
  },
  {
    title: "Email",
    dataIndex: "Email",
    key: "Email",
  },
  {
    title: "Comment",
    dataIndex: "Comment",
    key: "Comment",
  },
];

export default  function Comments() {
  const[dataSource,setdataSource]=useState([])
  
  try {
    useEffect(() => {
      getUserRol(getAccessTokenApi()).then((response)=>{
        // console.log(response==='admin')
        if(response!=='admin'){
          window.location.href = "/admin/instructions";
        }
    
        return;
      })
      get('contacts','contacts','').then((response) => {
        console.log(response)
        var aux=[]
        for (var i =0; i<response.length;i++){
          aux.push({
            Iteration: i,
            Id:response[i].idUser,
            Name:response[i].nombre,
            Comment:response[i].comentario,
            Date:response[i].hora,
            Email:response[i].email,
          })
        }
        setdataSource(aux)
      })

    }, []);
     
    
  } catch (err) {
  //  console.log(err);
  }

  return (
    <>
      <h2 style={{fontFamily: 'report-bold'}}>Comments: </h2>
      <div style={{border: '5px solid rgb(203,234,247)',marginBottom:'10px',minHeight:'75vh'}}>
        <Table
          dataSource={dataSource}
          columns={columns}
          scroll={{ y: 430, x: 200 }}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: false,
            pageSizeOptions: ["2", "5", "10", "20", "30"],
          }}
        />
      </div>
    </>
  );
}
